import { render, staticRenderFns } from "./applogin.vue?vue&type=template&id=0895f0fe"
import script from "./applogin.vue?vue&type=script&lang=js"
export * from "./applogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports